module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/brave.c72897c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/brave.jpg
// module id = h0tf
// module chunks = 0